import React from "react";
import PhaseOneAnimation from '../components/PhaseOneAnimation';
import Quote from "../components/Quote";
export default ({ isActive }) => {
  const defaultQuote = {
    author: '',
    position: '',
    img: null,
    quote: ['What if the drug is not approved?', 'Even trials that fail have value. The science becomes the foundation for future medical research.']
  }
  return (
    <div className="component">
      <PhaseOneAnimation isActive={isActive} lowerBg={true} hideOverflow={true} />
      <div className="drug-approval-text">
        <p>{'What if the drug is not approved? Even trials that fail have value. The science becomes the foundation for future medical research.'}</p>
      </div>
    </div>
  );
};
